import React from "react";
import { createRoot } from 'react-dom/client';
import '../../styles/components/cart-upsell.scss';
import { CartUpsellContainer } from "../react_components/CartUpsellContainer";

const rootElements = Array.from(document.querySelectorAll('[data-cart-upsell]'));

// creates the roots to render the react components
if (rootElements.length > 0) {
  rootElements.forEach(rootEl => {
    const root = createRoot(rootEl);
    const settings = JSON.parse(rootEl.previousElementSibling.innerHTML);

    if (root) {
      root.render(
        <CartUpsellContainer upsellJsonSettings={settings} />
      );
      rootEl._reactRootContainer = root;
    }
  });
}
